<template>
  <g-signin-button
    :params="googleSignInParams"
    @success="onSuccess"
    @error="onFailure">
    Sign in with Google
  </g-signin-button>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'


export default {
  name: 'LoginButton',



  props: {
    height: {
      type: Number
    },
    longtitle: {
      type: Boolean
    },
    width: {
      type: Number
    }
  },

  data() {
    return {
      show: false,
      googleSignInParams: {
        client_id: '65194020158-r5ilnjmk6p774v9rpb4e6948ksfquool.apps.googleusercontent.com'
      }
    }
  },

  methods: {
    ...mapActions('user', ['setUser']),
    onSuccess(googleUser) {
      // This only gets the user information: id, name, imageUrl and email
      this.setUser(googleUser.getBasicProfile())
    },
    onCurrentUser(googleUser) {
      // This only gets the user information: id, name, imageUrl and email
      this.setUser(googleUser.getBasicProfile())
    },
    onFailure(error) {
      console.log('OH NOES', error)
    }
  },

  computed: {
    ...mapGetters('config', ['google_login_client_id', 'google_login_hosted_domain', 'google_login_scope']),
    showLoginButton() {
        if(this.google_login_client_id) {
            return true
        }
        return false
    },
    // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
    params() {
        let params = {
            client_id: this.google_login_client_id, //"703391059089-pgn2k8t6rjo4922oo970odc26qt7n2it.apps.googleusercontent.com",
            hosted_domain: this.google_login_hosted_domain,
            scope: this.google_login_scope
        }
        return params
    },
    // only needed if you want to render the button with the google ui
    /*renderParams() {
        let params = {
            width: this.width,
            height: this.height,
            longtitle: this.longtitle
        }
        return params
    },*/
  }
}
</script>

<style>
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}
</style>
